import * as React from "react";
import { styled, alpha, ThemeProvider } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import AddCircle from "@mui/icons-material/AddCircle";
import { Button, colors, Grid, Stack } from "@mui/material";
import { grey } from "@mui/material/colors";
import theme from "./WsMuiTheme";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import _ from "underscore";
import { ExcelExport } from "./ImportExport";
import { useDispatch } from "react-redux";
import { StandardConst } from "./StandardConst";
import {
  AutoCompleteDropdownCard,
  InputDropdown,
  InputText,
} from "../Component/Form";
import { DateRange } from "../Component/Dashboard/Company/CompanyDashboard";
import { format } from "date-fns";
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: grey,
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  height: "30px",
  minheight: "30px",

  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchDefault = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: grey,
  },
  backgroundColor: grey[300],

  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",

  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(3)})`,
    transition: theme.transitions.create("width"),
    fontSize: ".8rem",
    width: "100%",
    border: "none",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

const AppbarComponent = ({
  title,
  isSearchRequired,
  isAddButtonRequired,
  setSearchContent,
  searchContent,
  onAddEvent,
  Exception,
  hideDefaultAddLabel,
  exportData,
  columns,
  excelExportFileName,
  isExcelExportButtonVisible,
  filterData,
  setFilterValues,
  filterValues,
  ExcluedFieldFromColumns,
  ExcelExportFieldNames,
  callBackEvent, buttonClass
}) => {
  callBackEvent ??= false;
  isExcelExportButtonVisible ??= false;
  ExcluedFieldFromColumns ??= [];
  ExcelExportFieldNames ??= [];
  filterData ??= [];
  filterValues ??= {};
  title ??= "";
  hideDefaultAddLabel ??= false;
  isSearchRequired ??= false;
  isAddButtonRequired ??= false;
  setSearchContent ??= (v) => {};
  searchContent ??= "";
  buttonClass ??= "";
  var inputBase = (
    <StyledInputBase
      placeholder={`Search ${title}`}
      id={`Search_${title}`}
      inputProps={{ "aria-label": "search" }}
      onChange={(e) => setSearchContent(e.target.value)}
      value={searchContent}
    />
  );

  const dispatch = useDispatch();

  // ExcluedFieldFromColumns, ExcelExportFieldNames ye hum us case me use krte hai jaha pr humne kuchh field jo directly available nahi the unko render ki madad se display kraya hai lekin excel me hume data se directly values ko lena hai
  // -- example - START --
  // ExcluedFieldFromColumns={["From", "Message"]}
  // ExcelExportFieldNames={[
  //   {ExcelColumnHeading: "From", DataColumnName: "CreatedBy"},
  //   {ExcelColumnHeading: "Message", DataColumnName: "Message"},
  //   {ExcelColumnHeading: "Notification Creation Date", DataColumnName: "CreatedOn", DataType: "DateTime"},
  // ]}
  // -- example - END --
  const ExportToExcel = () => {
    var columnsToBeExported = columns.filter(
      (f) =>
        (f.NotUseInExport ?? false) === false &&
        !StandardConst.ExcludeFieldsFromExcelExport.includes(f.Text)
    );

    // Which files are exclued from excel export # hum ye field ko data me se le rahe hai is liye columns me se in fields ko exclued kiya hai
    if (ExcluedFieldFromColumns.length > 0) {
      columnsToBeExported = columnsToBeExported.filter(
        (item) => !ExcluedFieldFromColumns.includes(item.Text)
      );
    }

    var dataOfColumnsToBeExported = _.map(exportData, (m) => {
      var object = {};

      // Additional columns and data inside the Excel file are created
      _.each(ExcelExportFieldNames, (oneObj) => {
        if (
          oneObj.DataType !== undefined &&
          oneObj.DataType === StandardConst.dataTypes.DateTime
        ) {
          object[oneObj.ExcelColumnHeading] =
            m[oneObj.DataColumnName] !== null && m[oneObj.DataColumnName] !== ""
              ? format(new Date(m[oneObj.DataColumnName]), "dd-MM-yyyy HH:mm a")
              : "";
        } else if (
          oneObj.DataType !== undefined &&
          oneObj.DataType === StandardConst.dataTypes.Date
        ) {
          object[oneObj.ExcelColumnHeading] =
            m[oneObj.DataColumnName] !== null && m[oneObj.DataColumnName] !== ""
              ? format(new Date(m[oneObj.DataColumnName]), "dd-MM-yyyy")
              : "";
        } else {
          object[oneObj.ExcelColumnHeading] =
            m[oneObj.DataColumnName] !== undefined &&
            m[oneObj.DataColumnName] !== null
              ? m[oneObj.DataColumnName]
              : "";
        }
      });

      _.each(columnsToBeExported, (singleColumn) => {
        // ye code achha nahi laga isko dubara dekhkr sahi krna hai (aisa sir ne kaha hai)
        if (
          singleColumn.Text === "Working Days" &&
          Array.isArray(m.workingDays)
        ) {
          object[singleColumn.Text] = m.workingDays
            .map((Val) => `${Val.Day}`)
            .join(",");
        } else {
          // if (singleColumn.exportValue) {
          //   object[singleColumn.Text] = singleColumn.exportValue(m);
          // }
          // else if (singleColumn.render) {
          //   if (singleColumn.render(m).props.Number) {
          //     object[singleColumn.Text] = singleColumn.render(m).props.Number;
          //   } else {
          //     object[singleColumn.Text] = Array.isArray(
          //       singleColumn.render(m).props.children
          //     )
          //       ? singleColumn.render(m).props.children.join("")
          //       : singleColumn.render(m).props.children;
          //   }
          // }
          // else if (singleColumn.Value !== undefined && singleColumn.Value !== null) {
          //   if (Array.isArray(singleColumn.Value)) {
          //     // [M,T,W,Th,F,Sa]
          //     object[singleColumn.Text] = singleColumn.Value.join("");
          //   } else {
          //     object[singleColumn.Text] =
          //       m[singleColumn.Value ?? singleColumn.Text];
          //   }
          // } 
           if (singleColumn.exportValue) {
            object[singleColumn.Text] = singleColumn.exportValue(m);
          }
          else if (singleColumn.render) {
            const rendered = singleColumn.render(m);
            
            // Check if rendered value has props (is a React element)
            if (rendered && typeof rendered === 'object' && rendered.props) {
              if (rendered.props.Number !== undefined) {
                object[singleColumn.Text] = rendered.props.Number;
              } else if (rendered.props.children !== undefined) {
                object[singleColumn.Text] = Array.isArray(rendered.props.children)
                  ? rendered.props.children.join("")
                  : rendered.props.children;
              } else {
                object[singleColumn.Text] = "";
              }
            } else {
              // Handle primitive values (string, number, etc.)
              object[singleColumn.Text] = rendered ?? "";
            }
          }
          else if (singleColumn.Value !== undefined && singleColumn.Value !== null) {
            if (Array.isArray(singleColumn.Value)) {
              // [M,T,W,Th,F,Sa]
              object[singleColumn.Text] = singleColumn.Value.join("");
            } else {
              object[singleColumn.Text] =
                m[singleColumn.Value ?? singleColumn.Text];
            }
          }
          
        }

        // object[singleColumn.Text] = singleColumn.render ?
        // (Array.isArray(singleColumn.render(m).props.children)) ? singleColumn.render(m).props.children.join('') : singleColumn.render(m).props.children
        // : m[singleColumn.Value ?? singleColumn.Text]
      });

      return object;
    });
    excelExportFileName = excelExportFileName
      ? excelExportFileName + "-" + Date.now().toString()
      : Date.now().toString();
    ExcelExport(dataOfColumnsToBeExported, excelExportFileName, dispatch);
  };

  const [appBarFilterState, setAppBarFilterState] = React.useState({});
  const handleChangeFilters = (val, filedName) => {
    setAppBarFilterState((prev) => ({
      ...prev,
      [filedName]: val,
    }));
  };

  React.useEffect(() => {
    if (callBackEvent) {
      callBackEvent(appBarFilterState);
    }
  }, [appBarFilterState]);

return (
  <>
    {(isSearchRequired ||
      isAddButtonRequired ||
      isExcelExportButtonVisible) && (
      <Box>
        <ThemeProvider theme={theme}>
          <AppBar
            position="static"
            elevation={0}
            color={
              isAddButtonRequired ||
              isExcelExportButtonVisible ||
              (onAddEvent || null) !== null
                ? "primary"
                : "default"
            }
            sx={{
              minHeight: 40,
              padding: 0,
              m: 0,
            }}
          >
            <Toolbar
              sx={{ minHeight: 30, margin: 0, padding: 0, width: "100%" }}
              style={{ minHeight: 30, margin: 0, padding: 0, width: "100%" }}
            >
              <Grid
                container
                justifyContent="space-between" // spaces items across row
                sx={{
                  alignItems: "center",
                  marginRight: 5,
                  padding: 0,
                }}
                className={buttonClass}
              >
                {/* ===== Search Bar ===== */}
                {isSearchRequired && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg="auto"
                    style={{ margin: 0, padding: 0 }}
                  >
                    {isSearchRequired &&
                      (isAddButtonRequired ||
                        isExcelExportButtonVisible ||
                        (onAddEvent || null) !== null) && (
                        <Search>
                          <SearchIconWrapper>
                            <SearchIcon sx={{ fontSize: 20 }} />
                          </SearchIconWrapper>
                          {inputBase}
                        </Search>
                      )}
                    {isSearchRequired &&
                      !(
                        isAddButtonRequired ||
                        isExcelExportButtonVisible ||
                        (onAddEvent || null) !== null
                      ) && (
                        <SearchDefault>
                          <SearchIconWrapper>
                            <SearchIcon sx={{ fontSize: 20 }} />
                          </SearchIconWrapper>
                          {inputBase}
                        </SearchDefault>
                      )}
                  </Grid>
                )}

                {/* ===== Filters ===== */}
                {filterData.length > 0 &&
                  filterData.map((item) => {
                    if (item.FilterType === "INPUT") {
                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          justifyContent="space-between" // spaces items across row
                          lg="auto"
                          key={item.FieldName}
                          sx={{ margin: 0, padding: 0 }}
                        >
                          <InputText
                            className="text-white border-0"
                            style={{
                              backgroundColor: "rgba(255, 255, 255, 0.15)",
                              height: "30px",
                              borderRadius: "5px",
                              width: "100%",
                            }}
                            placeholder={item.FilterPlaceholder}
                            name={item.FieldName}
                            setValue={(val) =>
                              handleChangeFilters(val, item.FieldName)
                            }
                            value={appBarFilterState[item.FieldName] ?? ""}
                          />
                        </Grid>
                      );
                    }

                    if (item.FilterType === "DATE") {
                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg="auto"
                          key={item.FieldName}
                        >
                          <DateRange
                            DefaultDate={
                              item?.DefaultDate !== undefined
                                ? item?.DefaultDate
                                : ""
                            }
                            ResetDateRange={
                              Object.keys(appBarFilterState).length === 0
                            }
                            type="day"
                            ButtonColor="inherit"
                            setDateRange={({ StartDate }) => {
                              if (StartDate) {
                                handleChangeFilters(
                                  format(new Date(StartDate), "yyyy-MM-dd"),
                                  item.FieldName
                                );
                              }
                            }}
                          />
                        </Grid>
                      );
                    }

                    if (item.FilterType === "MONTH") {
                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg="auto"
                          key={item.FieldName}
                        >
                          <DateRange
                            DefaultDate={item?.DefaultDate || ""}
                            ResetDateRange={
                              Object.keys(appBarFilterState).length === 0
                            }
                            type="month"
                            ButtonColor="inherit"
                            setDateRange={({ StartDate }) => {
                              if (StartDate) {
                                handleChangeFilters(
                                  format(new Date(StartDate), "yyyy-MM-dd"),
                                  item.FieldName
                                );
                              }
                            }}
                          />
                        </Grid>
                      );
                    }

                    if (item.FilterType === "AUTOCOMPLETE") {
                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg="auto"
                          key={item.FieldName}
                        >
                          <AutoCompleteDropdownCard
                            data={item.FilterData}
                            optionText={item?.OptionText}
                            labelCss="text-light"
                            setValue={(val) =>
                              handleChangeFilters(val, item.FieldName)
                            }
                            style={{
                              "& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input":
                                {
                                  color: "white", // affects input text
                                },
                            }}
                            sx={{
                              width: "100%",
                              color: "white", // affects dropdown options text
                              minWidth: {
                                xs: "150px",
                                sm: "180px",
                                md: "200px",
                              },
                              "& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input":
                                {
                                  color: "white", // affects input text
                                },
                              "& .MuiInputBase-root": {
                                minHeight: "30px",
                                fontSize: "0.75rem",
                                padding: "2px 8px",
                                color: "white",
                              },
                              "& .MuiOutlinedInput-input": {
                                color: "white", // selected value text color
                              },
                            }}
                            value={item?.FilterData[0]}
                          />
                        </Grid>
                      );
                    }

                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg="auto"
                        key={item.FieldName}
                      >
                        <InputDropdown
                          className={`border-0 ${item.FieldName}`}
                          style={{
                            backgroundColor: "rgba(255, 255, 255, 0.15)",
                            height: "30px",
                            borderRadius: "5px",
                            width: "100%",
                          }}
                          name={item.FieldName}
                          setValue={(val) =>
                            handleChangeFilters(val, item.FieldName)
                          }
                          ddOpt={[
                            {
                              text: item.DefaultAllValuesText ?? "All",
                              value: "",
                            },
                          ].concat(item.FilterData)}
                          value={appBarFilterState[item.FieldName] ?? ""}
                        />
                      </Grid>
                    );
                  })}

                {/* ===== Reset Button ===== */}
                {filterData.length > 0 && (
                  <Grid item xs={12} sm={6} md={6} lg="auto">
                    <Button
                      className="text-white"
                      onClick={() => setAppBarFilterState({})}
                      sx={{ width: "100%" }}
                    >
                      Reset
                    </Button>
                  </Grid>
                )}
                 {/* ===== Excel Export ===== */}
                {!isAddButtonRequired && isExcelExportButtonVisible && (
                  <Grid item xs={12} sm={6} md={6} lg="auto">
                    <Button
                      variant="outline-success"
                      onClick={() => ExportToExcel()}
                      sx={{ width: "100%" }}
                    >
                      <i className="fa fa-file-excel-o me-2"></i> Export
                    </Button>
                  </Grid>
                )}

           
                {/* ===== Add Button ===== */}
                {isAddButtonRequired && (
                  <Grid item xs={12} sm={6} md={6} lg="auto" className="d-flex flex-row">
                    <Button
                      variant="outline-success"
                      onClick={() => ExportToExcel()}
                      sx={{ width: "100%" }}
                    >
                      <i className="fa fa-file-excel-o me-2"></i> Export
                    </Button>
                    <>
                      {/* Desktop Add Button */}
                      <Button
                        color="inherit"
                         className={buttonClass}
                        id={`Add_${title}`}
                        onClick={() => onAddEvent?.()}
                        sx={{
                          display: { xs: "none", md: "flex" }, // only show on md+
                          width: "100%",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <i className="fa fa-plus-circle me-2"></i>
                          {`${hideDefaultAddLabel ? "" : "Add"} ${title}`}
                        </Box>
                      </Button>

                      {/* Mobile Icon Button */}
                      <IconButton
                        size="large"
                        edge="end"
                        onClick={() => onAddEvent?.()}
                        color="inherit"
                        sx={{
                          display: { xs: "flex", md: "none" }, // only show on xs/sm
                          ml: 1,
                        }}
                      >
                        <AddCircle />
                      </IconButton>
                    </>
                  </Grid>
                )}
              </Grid>
            </Toolbar>
          </AppBar>
        </ThemeProvider>
      </Box>
    )}
  </>
);


};
export default AppbarComponent;
